import {Button} from "@mui/material";
import type {ButtonProps} from "@mui/material/Button";
import {brandColors} from "../../theme/brandColors.ts";

const SubmitButton = (props: ButtonProps) => {
    const {sx, ...rest} = props;

    const baseSx = {
        "&.MuiButton-root": {
            width: "auto",
            minWidth: "180px",
            minHeight: "48px",
            backgroundColor: brandColors.yellow,
            color: brandColors.ink,
            fontFamily: "'Lato', system-ui, sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: 1,
            textTransform: "none",
            borderRadius: "4px",
            boxShadow: "none",
            paddingLeft: "24px",
            paddingRight: "24px",
            border: "none",
            "&:hover": {backgroundColor: brandColors.yellowHover, boxShadow: "none"},
            "&.Mui-disabled": {backgroundColor: brandColors.border, color: brandColors.muted4},
        },
    };

    return (
        <Button
            variant="contained"
            disableElevation
            sx={[
                baseSx,
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
            {...rest}
        />
    );
};

export default SubmitButton;
